var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlertTurn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1966 29.0816C19.1966 29.6987 19.4392 30.2904 19.8712 30.7267C20.3032 31.163 20.8891 31.4082 21.5 31.4082C22.1109 31.4082 22.6968 31.163 23.1288 30.7267C23.5608 30.2904 23.8034 29.6987 23.8034 29.0816C23.8034 28.4646 23.5608 27.8728 23.1288 27.4365C22.6968 27.0002 22.1109 26.7551 21.5 26.7551C20.8891 26.7551 20.3032 27.0002 19.8712 27.4365C19.4392 27.8728 19.1966 28.4646 19.1966 29.0816ZM19.9644 14.3469V23.2653C19.9644 23.4786 20.1371 23.6531 20.3483 23.6531H22.6517C22.8629 23.6531 23.0356 23.4786 23.0356 23.2653V14.3469C23.0356 14.1337 22.8629 13.9592 22.6517 13.9592H20.3483C20.1371 13.9592 19.9644 14.1337 19.9644 14.3469ZM42.7924 35.6735L22.8293 0.77551C22.5317 0.256888 22.0183 0 21.5 0C20.9817 0 20.4635 0.256888 20.1707 0.77551L0.207566 35.6735C-0.382691 36.7107 0.35633 38 1.53684 38H41.4632C42.6437 38 43.3827 36.7107 42.7924 35.6735ZM5.19356 34.3212L21.5 5.81148L37.8064 34.3212H5.19356Z",
    fill: "#FF6F61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertTurn);
export default __webpack_public_path__ + "static/media/ic_alert_turn.9f660fa6e6235753aa8a49339a2381eb.svg";
export { ForwardRef as ReactComponent };